// AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // const [user, setUser] = useState(null);
  const [user, setUser] = useState({});
  useEffect(() => {
    // Retrieve the token from your preferred source (e.g., localStorage, sessionStorage)
    const token = sessionStorage.getItem("id_token");
    if (token) {
      try {
        // Decode the token without using a third-party library
        const decodedToken = decodeJWT(token);
        const userAuthorities = decodedToken.authority || [];
        const userSites = decodedToken.site || [];
        // Set user and authorities in the global state
        const userObject = {
          username: decodedToken.sub,
          authorities: userAuthorities,
          sites: userSites,
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userObject));
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  const decodeJWT = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(atob(base64));
  };

  const login = (token) => {
    try {
      // Decode the token without using a third-party library
      const decodedToken = decodeJWT(token);
      const userAuthorities = decodedToken.authority || [];
      const userSites = decodedToken.site || [];
      // Set user and authorities in the global state
      // setUser({
      //   username: decodedToken.sub,
      //   authorities: userAuthorities,
      // });
      const userObject = {
        username: decodedToken.sub,
        authorities: userAuthorities,
        sites: userSites,
      };

      setUser(userObject);
      // Save the token to your preferred source (e.g., localStorage, sessionStorage)
      sessionStorage.setItem("userInfo", JSON.stringify(userObject));
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  };

  const logout = () => {
    // Clear user and token from the global state and storage
    setUser(null);
    sessionStorage.removeItem("id_token");
    sessionStorage.removeItem("userInfo");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// export const useAuth = () => {
//   return useContext(AuthContext);
//   // const { user, login, logout } = useContext(AuthContext);
//   // return { user, login, logout };
// };

export const useAuth = () => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  const { user: rawUser } = authContext;
  const user = rawUser || {};

  return { ...authContext, user };
};
